import { Component, computed, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import {
  AutopilotImportHistoryEntry,
  DeviceImportState,
} from '../../../../../Interfaces/api/Intune/autopilot-devices.interface';
import { TranslateService } from '@ngx-translate/core';
import { ImportHistoryDetailDialogData } from '../../../Interfaces/import-history-detail-dialog.interface';

@Component({
  selector: 'av-import-history-detail-dialog',
  standalone: true,
  imports: [COMMON_IMPORTS],
  templateUrl: './import-history-detail-dialog.component.html',
  styleUrls: [
    './import-history-detail-dialog.component.scss',
    '../../../../../../assets/theme/cutom/_av-dialog.scss',
  ],
})
export class ImportHistoryDetailDialogComponent {
  private readonly _dialogRef = inject(MatDialogRef<ImportHistoryDetailDialogComponent>);
  private readonly _translate = inject(TranslateService);
  private readonly data = inject(MAT_DIALOG_DATA) as ImportHistoryDetailDialogData;

  public readonly deviceStateEntries = computed(() => {
    const states = this.data.entry.metadata?.device_states;
    return states ? Object.entries(states).map(([id, state]) => ({ id, state })) : [];
  });

  get entry(): AutopilotImportHistoryEntry {
    return this.data.entry;
  }

  getDeviceStatusClass(state: DeviceImportState): string {
    const status = state.deviceImportStatus ?? '';
    const errorName = (state.deviceErrorName ?? 'None').trim();
    const isSuccess = status === 'complete' && (errorName === '' || errorName === 'None');
    const isError = status === 'error' || (errorName !== '' && errorName !== 'None');
    if (isSuccess) return 'status-success';
    if (isError) return 'status-error';
    return 'status-pending';
  }

  translateErrorName(errorName: string): string {
    if (!errorName || errorName === 'None')
      return this._translate.instant('app.autopilot_devices.history.device_errors.none');
    const key = `app.autopilot_devices.history.device_errors.${errorName}`;
    const translated = this._translate.instant(key);
    return translated !== key ? translated : errorName;
  }

  getImportStatusKey(deviceImportStatus: string): string {
    return `app.autopilot_devices.history.import_status_values.${deviceImportStatus || 'unknown'}`;
  }

  close(): void {
    this._dialogRef.close();
  }
}
